const DOMAIN = "https://d363r49np5tk98.cloudfront.net/";
const BUCKET = "hautesociete-user-photos-v2";

/**
 * @description Serverless Image Handler
 * @url https://d2qnb1baxbnyux.cloudfront.net/index.html
 */
export const ImgSrc = (awsPath: string) => {
  const request = {
    bucket: BUCKET,
    key: awsPath,
  };

  const strRequest = JSON.stringify(request);
  const encRequest = btoa(strRequest);

  return `${DOMAIN}${encRequest}`;
};
